/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 2/13/13
 * Time: 2:59 PM
 * To change this template use File | Settings | File Templates.
 */
/*
 here we will load the applications modules and start the application
 */


define(function (require) {
    "use strict";

    // list all the dependencies in a more readable format
    var LE = require("app");
    var LEConfig = require("assets/config/le-env-conf");
    var LiveEngageLayoutController = require("controllers/LiveEngageLayoutController");
    var UserAssistanceController = require("controllers/UserAssistanceController");
    var MigrationActivationSource = require("src/components/migration-activation/MigrationActivationSource");
    var $ = require("jquery");
    var CONST = require("const");
    var Logger = require("logger");
    var NotificationCenter = require("notificationCenter/notificationCenter");
    var DesktopNotification = require("notificationCenter/appenders/DesktopNotification");
    var TabTitleNotification = require("src/components/notificationCenter/appenders/TabTitleNotification");
    var PersonaNotification = require("src/components/notificationCenter/appenders/PersonaNotification");
    var TopBarNotification = require("src/components/notificationCenter/appenders/TopBarNotification");
    var DomUtilities = require("infra-util/DomUtilities");
    var LPMtagConfigModel = require("models/LPtagConfigModel");

    var packLoader = require("src/packLoader");

    /*
     add initializers that will run when the application is started
     */
    LE.on("initialize:before", function () {

    });

    /*
     add initializers that will run when the application is started
     */
    LE.on("initialize", function () {
    });

    /*
     add callback to run when app is started after all initializers have run
     */
    LE.on("start", function (options) {
        //remove the start loader img from dom
        $(".startLoaderImg").remove();

        //set user assistance controller
        LE.userAssistanceController = new UserAssistanceController({
            application: LE,
            vent: LE.vent,
            translator: LE.translator,
            isFirstTimeLogin: LE.isFirstTimeLogin(),
            sessionManager: LE.sessionManager,
            persistenceManager: LE.persistenceManager
        });

         //Create the application main view controller
        var controller = new LiveEngageLayoutController({
            application: LE
        });

         //Kick-start the controller
        controller.start();

         //Navigate to the requested view inside the application
        LE.navigateToEntryPointUrl();

        //set LPtag
        setLPtag();

        //handle creating default campaign/cms/auto messeges
        if (!LE.sessionManager.hasLiveEngage2Feature() && LE.sessionManager.hasMigratingFeature()) {
            var migrationController = new MigrationActivationSource({
                application: LE
            });
            migrationController.onLogin();
        }
        setNotificationCenter();
    });

    // This is the entry point to my app, it will be called after user is authenticated.
    var loadAndStart = function () {
        // Now load the modules

        // This is done here and not inside LEApplication.js since
        // It involves loading all application modules where each module
        // Is requiring the application - to avoid cyclic dependency,
        // This should be located after the application had been loaded


        // todo - no need for async loading here?
        // Init regular expression extensions
        require(["crossDomain"], function () {

            packLoader.load('load', function () {

                // Kick-start the application
                LE.start();
            });
        });
    };

    // Authenticate the user
    LE.authenticate({success: loadAndStart});

    var setLPtag = function () {

        var customizationObj = LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.LE_UI_CUSTOMIZATION);
        if (customizationObj && (customizationObj.avoidSupportAccountTagging === "true" || customizationObj.avoidSupportAccountTagging === true)) {
            // This is not a real account, it's a hack for CafeX
            // CafeX accounts should not be tagged with the real support account but the tag is required for engagement window
            LE.LPtag_mtaconfig.siteId = "dummySupportAccount";
        }else{
            // start LPTag refresh, lets wait until LE App has fully started before fetching first time
            LE.LPMtagModel = new LPMtagConfigModel({});
            setTimeout(function () {
                LE.LPMtagModel.startRefresh();
            }, 30000);
        }

        var onTagAdded = function () {
            lpTagSendUDEs();
            lpTagSetLog();
            LE.vent.trigger("LPtag_mtaconfig:loaded");
        };

        // will trigger a callback after the array is required.
        require(["assets/js/lib/liveperson/LPtag_mtagconfig.js"], onTagAdded);

        // todo - dynamic require with webpack script-loader?
        // DomUtilities.addScriptTag("assets/js/lib/liveperson/LPtag_mtagconfig.js",
        //     onTagAdded, null, "scriptLpTag");
    };

    var lpTagSendUDEs = function () {
        LE.lpTagAddVar([
            {name: "DefaultPersona", val: LE.sessionManager.getDefaultPersona()},
            {name: "ActivePersona", val: LE.sessionManager.getActivePersona()},
            {name: "UserId", val: LE.sessionManager.getUserId()},
            {name: "AccountId", val: LE.sessionManager.getAccountId()},
            {name: "LoginName", val: LE.sessionManager.getLoginName()}
        ]);
        if (LE.siteSettings) {
            LE.lpTagAddVar([
                {name: "AccountTimeZone", val: LE.siteSettings.timeZoneSettings.getCurrentTimeZone()}
            ]);
        }
    };

    var lpTagSetLog = function () {
        window.lpTaglogListeners = window.lpTaglogListeners || [];
        window.lpTaglogListeners.push(function (msg, type, callingMethod) {
            if (window.lpTag && (window.lpTag.isLogToLeLogger === undefined || window.lpTag.isLogToLELogger !== false)) {
                var leLogger = Logger.getLogger("lpTag");
                switch (type) {
                    case CONST.LP_TAG_LOG_TYPES.DEBUG:
                        leLogger.debug(msg, callingMethod);
                        break;
                    case CONST.LP_TAG_LOG_TYPES.ERROR:
                        leLogger.error(msg, callingMethod);
                        break;
                    case CONST.LP_TAG_LOG_TYPES.INFO:
                        leLogger.info(msg, callingMethod);
                        break;
                    case CONST.LP_TAG_LOG_TYPES.METRICS:
                        leLogger.metrics(msg, callingMethod);
                        break;
                    default:
                        leLogger.debug(msg, callingMethod, {"type": type});
                        break;
                }
            }
        });

    };

    var setNotificationCenter = function () {
        var opts = {
            application: LE
        };

        LE.notificationCenter = new NotificationCenter();
        LE.notificationCenter.initialize(opts);
        if (!LE.sessionManager.isExternal()) {
            LE.notificationCenter.addAppender({name: "DesktopNotification", appender: new DesktopNotification(opts)});
            LE.notificationCenter.addAppender({name: "TabTitleNotification", appender: new TabTitleNotification(opts)});
            LE.notificationCenter.addAppender({name: "PersonaNotification", appender: new PersonaNotification(opts)});
            LE.notificationCenter.addAppender({name: "TopBarNotification", appender: new TopBarNotification(opts)});
        }
    };
    return LE;
});
